import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { usePromocodesStore } from '@stores/promocodes'

import { MAX_PER_PAGE, getFirstQueryValue, toPaginationValue } from '@helpers/route'

import { defineNuxtRouteMiddleware } from '#app'

/**
 * `/promocodes` — query → store filters, mirroring `middleware/users.ts`.
 */
export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedGeneric) => {
  const store = usePromocodesStore()

  const discount = getFirstQueryValue(to.query?.discount)

  store.setFilterSearch(getFirstQueryValue(to.query?.q) || null)
  store.setFilterStatus(getFirstQueryValue(to.query?.status) || null)
  store.setFilterDiscount(discount ? Number(discount) : null)
  store.setFilterFrom(getFirstQueryValue(to.query?.from) || null)
  store.setFilterTo(getFirstQueryValue(to.query?.to) || null)

  store.setCurrentPage(toPaginationValue(to.query?.page, 1))
  store.setPerPage(toPaginationValue(to.query?.per_page, store.getPerPage, MAX_PER_PAGE))
})
